import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { PageableResponse } from '@core/interface/pageable.interface';
import { ListCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/list-company-collector-merchant.dto-request';
import { GetCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/get-company-collector-merchant.dto-request';
import { CompanyCollectorMerchantResponseDto } from '@domain/company-collector-merchant/dtos/company-collector-merchant-response.dto';
import { CreateCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/create-company-collector-merchant-request.dto';
import { UpdateCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/update-company-collector-merchant-request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorMerchantService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('company/collector/merchant');
  }

  list(request: ListCompanyCollectorMerchantRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<CompanyCollectorMerchantResponseDto>>
    >(queryUrl, {
      params: { ...request },
    });
  }

  get(request: GetCompanyCollectorMerchantRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<
      ApiResponse<CompanyCollectorMerchantResponseDto[]>
    >(queryUrl, {
      params: { ...request } as any,
    });
  }

  create(request: CreateCompanyCollectorMerchantRequestDto) {
    const queryUrl = `${this.getApiUrl()}/`;
    return this.http.post<ApiResponse<CompanyCollectorMerchantResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateCompanyCollectorMerchantRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<CompanyCollectorMerchantResponseDto>>(
      queryUrl,
      body,
    );
  }

  delete(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}`;
    return this.http.delete<ApiResponse<CompanyCollectorMerchantResponseDto>>(
      queryUrl,
    );
  }
}
